// Import model
import { EmailFieldOptions } from '../models/EmailFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for EmailFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class EmailFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a EmailFieldOptions instance
   */
  static deserialize(json: string): EmailFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a EmailFieldOptions instance
   */
  static fromObject(obj: any): EmailFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to EmailFieldOptions');
    }


    const instance: EmailFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      _2D5C9761: obj['_2d5c9761'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of EmailFieldOptions instances
   */
  static deserializeArray(json: string): EmailFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a EmailFieldOptions instance to a JSON string
   */
  static serialize(instance: EmailFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a EmailFieldOptions instance to a plain object
   */
  static toObject(instance: EmailFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      '_2d5c9761': instance._2D5C9761,
    };
  }

  /**
   * Serializes an array of EmailFieldOptions instances to a JSON string
   */
  static serializeArray(instances: EmailFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
